module.exports = __webpack_public_path__ + "img/1-2.cd44e00d.svg";